import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from './useAuth'

export function AuthGuard() {
  const { ready, user, verifyState } = useAuth()
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center text-surface-400">
        Loading…
      </div>
    )
  }
  if (!user) return <Navigate to="/" replace />
  if (verifyState === 'unprovisioned' || verifyState === 'error') {
    return <Navigate to="/" replace />
  }
  if (verifyState !== 'verified') {
    return (
      <div className="min-h-screen flex items-center justify-center text-surface-400">
        Verifying session…
      </div>
    )
  }
  return <Outlet />
}
